import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Toastr } from 'src/app/core-module/models/Utils/toastr';
import { ToastrService } from 'src/app/core-module/services/toastr.service';

@Component({
    selector: 'app-toastr-holder',
    templateUrl: './toastr-holder.component.html',
    styleUrl: './toastr-holder.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ToastrHolderComponent {

  public toastrs: Toastr[] = [];
  public id:number = 1;
  private toastrSubscription: Subscription;

  constructor(public toastrService: ToastrService){}

  ngOnInit(){
    this.toastrSubscription = this.toastrService.toastrStream().subscribe(
      (t:Toastr) => {
        this.id++;
        t.TempID = this.id;
        this.toastrs.push(t);
        setTimeout(()=>this.removeToastr(t),t.Duration)
      }
    ); 
  }

  removeToastr(toastr:Toastr){
    var index:number = this.toastrs.findIndex(e=>e.TempID == toastr.TempID);
    this.toastrs.splice(index,1);
  }
  showToastrs(){
    //return this.toastrs.length>0;
    return true;
  }

}
